/**
 * @generated SignedSource<<7943293f5c7bb8f22d43b8fef2f82dee>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroCarousel_user">;
  readonly " $fragmentType": "HpSharedHeroModule_user";
};
export type HpSharedHeroModule_user$key = {
  readonly " $data"?: HpSharedHeroModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedHeroCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ecf90280682751211bc8992602b1e00e";

export default node;
